<div class="rfe-wizard">

	<div class="rfe-wizard-head">
		<h2 class="rfe-wizard-title h-reset">
			<svg width="1em" class="svg-middle rfe-wizard-title-icon" viewBox="0 0 384 512" aria-hidden="true" focusable="false">
				<use xlink:href="@Assets/svg/symbol-defs.svg#file-invoice" />
			</svg>
			{{ $t('vm.components.popin.cancel-rfe.title') }}
		</h2>

		<ol class="rfe-stepper">
			<li v-for="step in steps" :key="`cancel-rfe-step-${step.number}`" class="rfe-step" :class="stepStatus(step.number)">
				<span class="rfe-step-badge">
					<svg v-if="stepStatus(step.number) === 'is-done'" width="1em" class="svg-middle" viewBox="0 0 512 512" aria-hidden="true" focusable="false">
						<use xlink:href="@Assets/svg/symbol-defs.svg#check" />
					</svg>
					<span v-else>{{ step.number }}</span>
				</span>
				<span class="rfe-step-label">{{ step.label }}</span>
			</li>
		</ol>
	</div>

	<div class="rfe-wizard-body">

		<div v-show="currentStepKey === 'scope'" class="rfe-step-content">
			<p class="rfe-question text-center"><strong>{{ $t('vm.components.popin.cancel-rfe.scope.title') }}</strong></p>

			<div class="choices">
				<radio-frame id="cancel-scope-principal" name="cancel-scope-group"
							 v-model="selectedChoice" radio-value="principal" default-class="p-like">
					<span class="rfe-sub-identity">
						<span class="rfe-sub-name">{{ $t('vm.components.popin.cancel-rfe.scope.principal-label') }}</span>
						<span class="rfe-sub-email">{{ $t('vm.components.popin.cancel-rfe.scope.principal-help') }}</span>
					</span>
				</radio-frame>

				<radio-frame v-if="officesWithSubstitute.length > 0" id="cancel-scope-substitutes" name="cancel-scope-group"
							 v-model="selectedChoice" radio-value="substitutes" default-class="p-like">
					<span class="rfe-sub-identity">
						<span class="rfe-sub-name">{{ $t('vm.components.popin.cancel-rfe.scope.substitutes-label') }}</span>
						<span class="rfe-sub-email">{{ $t('vm.components.popin.cancel-rfe.scope.substitutes-help') }}</span>
					</span>
				</radio-frame>
			</div>

			<div v-if="selectedChoice === 'principal'" class="rfe-refuse-block">
				<div class="rfe-refuse-warning notice-warning">
					<p class="rfe-notice-line">
						<svg width="1em" class="svg-middle" viewBox="0 0 576 512" aria-hidden="true">
							<use xlink:href="@Assets/svg/symbol-defs.svg#exclamation-triangle" />
						</svg>
						<span>{{ $t('vm.components.popin.cancel-rfe.principal.cascade-warning') }}</span>
					</p>
				</div>
			</div>
		</div>

		<div v-show="currentStepKey === 'substitutes'" class="rfe-step-content">
			<h3 class="rfe-step-title h-reset">{{ $t('vm.components.popin.cancel-rfe.substitutes.title') }}</h3>
			<p class="rfe-step-subtitle">{{ $t('vm.components.popin.cancel-rfe.substitutes.subtitle') }}</p>

			<div class="rfe-sub-toolbar">
				<span class="rfe-sub-card-count">{{ $tc('vm.components.popin.cancel-rfe.substitutes.selected-count', selectedSubstituteCount, { count: selectedSubstituteCount }) }}</span>
				<button type="button" class="btn btn-default rfe-sub-selectall" @click="toggleAllSubstitutes">
					{{ isAllSelected ? $t('vm.components.popin.cancel-rfe.substitutes.unselect-all') : $t('vm.components.popin.cancel-rfe.substitutes.select-all') }}
				</button>
			</div>

			<div v-for="office in officesWithSubstitute" :key="`cancel-rfe-office-${office.id}`" class="rfe-office">
				<p class="rfe-office-name">
					<svg width=".85em" class="svg-middle" viewBox="0 0 384 512" aria-hidden="true">
						<use xlink:href="@Assets/svg/symbol-defs.svg#map-marker-alt" />
					</svg>
					{{ office.name }}
				</p>

				<div class="rfe-sub-card">
					<div v-if="officesWithSubstitute.length > 1" class="rfe-sub-card-head">
						<span class="rfe-sub-card-count">{{ $tc('vm.components.popin.cancel-rfe.substitutes.selected-count', officeSelectedCount(office), { count: officeSelectedCount(office) }) }}</span>
					</div>

					<div class="rfe-sub-card-body">
						<div v-for="substitute in substitutesOf(office)" :key="`cancel-rfe-sub-${office.id}-${substitute.id}`" class="rfe-sub-row">
							<checkbox-frame :id="`cancel-rfe-sub-${office.id}-${substitute.id}`"
											:value="isSubstituteSelected(office.id, substitute.id)"
											@input="toggleSubstitute(office.id, substitute.id, $event)"
											:title="substituteNameWithEmail(substitute)">
								<span class="rfe-sub-identity">
									<span class="rfe-sub-name">{{ substituteDisplayName(substitute) }}</span>
									<span class="rfe-sub-email">{{ substitute.email }}</span>
								</span>
							</checkbox-frame>
						</div>
					</div>
				</div>
			</div>
		</div>

		<div v-show="currentStepKey === 'recap'" class="rfe-step-content">
			<h3 class="rfe-step-title h-reset">{{ $t('vm.components.popin.cancel-rfe.recap.title') }}</h3>

			<ul class="rfe-recap-lines">
				<li v-if="selectedChoice === 'principal'" class="rfe-recap-line">
					<span class="rfe-recap-line-info">
						<span class="rfe-recap-line-title">{{ $t('vm.components.popin.cancel-rfe.recap.line-principal') }}</span>
						<span class="rfe-recap-line-sub">{{ $t('vm.components.popin.cancel-rfe.recap.line-principal-sub', [principalName]) }}</span>
					</span>
				</li>

				<li v-for="detail in selectedSubstituteDetails" :key="`cancel-rfe-recap-${detail.office.id}-${detail.substitute.id}`" class="rfe-recap-line">
					<span class="rfe-recap-line-info">
						<span class="rfe-recap-line-title">{{ $t('vm.components.popin.cancel-rfe.recap.line-substitute', [substituteDisplayName(detail.substitute)]) }}</span>
						<span class="rfe-recap-line-sub">{{ $t('vm.components.popin.cancel-rfe.recap.line-substitute-role') }}</span>
					</span>
				</li>
			</ul>

			<p v-if="selectedChoice === 'principal'" class="rfe-recap-note">
				<svg width="1em" class="svg-middle" viewBox="0 0 576 512" aria-hidden="true" focusable="false">
					<use xlink:href="@Assets/svg/symbol-defs.svg#exclamation-triangle" />
				</svg>
				{{ $t('vm.components.popin.cancel-rfe.recap.principal-note') }}
			</p>

			<div class="refuse-reason">
				<textarea-frame id="cancel-rfe-reason" v-model="reasonText" class="grid-item-full"
						 :label="$t('vm.components.popin.cancel-rfe.reason.label')"
						 :placeholder="$t('vm.components.popin.cancel-rfe.reason.placeholder')"
						 :title="$t('vm.components.popin.cancel-rfe.reason.title')"
						 :errorTest="isReasonTooLong"
						 :errorMsg="reasonMessage" />
			</div>

			<div class="rfe-refuse-warning notice-warning">
				<p class="rfe-notice-line">
					<svg width="1em" class="svg-middle" viewBox="0 0 576 512" aria-hidden="true">
						<use xlink:href="@Assets/svg/symbol-defs.svg#exclamation-triangle" />
					</svg>
					<span>{{ $t('vm.components.popin.cancel-rfe.recap.warning') }}</span>
				</p>
			</div>
		</div>

	</div>

	<div class="rfe-wizard-foot">
		<span class="rfe-wizard-amount"></span>

		<div class="rfe-wizard-actions">
			<button-action default-class="btn" btn-class="btn-default" :disabled="loading || submitted"
						   :title="backLabel" @click.native="back">
				{{ backLabel }}
			</button-action>

			<button-action v-if="!showConfirm" default-class="btn" btn-class="btn-info" :disabled="!canGoNext"
						   :title="nextLabel" @click.native="next">
				{{ nextLabel }}
				<svg width="1em" class="svg-middle" viewBox="0 0 320 512" aria-hidden="true" focusable="false">
					<use xlink:href="@Assets/svg/symbol-defs.svg#angle-right" />
				</svg>
			</button-action>

			<button-action v-else default-class="btn" btn-class="btn-danger" :loading="loading || submitted"
						   :disabled="!canConfirm" :title="confirmLabel" @click.native="confirm">
				{{ confirmLabel }}
				<svg width="1em" class="svg-middle" viewBox="0 0 512 512" aria-hidden="true" focusable="false">
					<use xlink:href="@Assets/svg/symbol-defs.svg#check" />
				</svg>
			</button-action>
		</div>
	</div>

</div>
